import keyService, * as chord from "data/key"

interface Undoable {
  undofunc: Function,
  redofunc: Function
}

keyService.stream().subscribe(k => {
  switch(true) {
    case k.chord === chord.SHIFT_ALT_Z && k.down === true:
      undo()
      break
    case k.chord === chord.SHIFT_ALT_R && k.down === true:
      redo()
      break
  }
})

const undoStackAggregate = {}
const redoStackAggregate = {}
const MAX_STACK_SIZE = 100
let undoing = false

const push = (type: "undo" | "redo", payload: Undoable) => {
  const aggregator = type === "undo" ? undoStackAggregate : redoStackAggregate

  const path = window.location.pathname
  if(aggregator[path]) {
    aggregator[path].push(payload)
    if(aggregator[path].length > MAX_STACK_SIZE) aggregator[path].shift()
  } else {
    aggregator[path] = []
    aggregator[path].push(payload)
  }
}

const undo = () => {
  const path = window.location.pathname
  const stack = undoStackAggregate[path]
  if(stack && stack.length) {
    const { undofunc, redofunc } = stack.pop()
    if(undofunc && redofunc) {
      undoing = true
      push("redo", {redofunc, undofunc})
      undofunc()
    }
  }
}

const redo = () => {
  const path = window.location.pathname
  const stack = redoStackAggregate[path]
  if(stack && stack.length) {
    const { redofunc } = stack.pop()
    if(redofunc) redofunc()
  }
}

const push_undo = (payload: Undoable) => {
  if(undoing) undoing = false
  else push("undo", payload)
}

export {
  push_undo
}
